import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appStepAnimation]'
})
export class StepAnimationDirective implements OnChanges {
  @Input() appStepAnimation!: number;
  @Input() stepDirection: 'forward' | 'backward' = 'forward';
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  private static stylesInjected = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.injectStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appStepAnimation']) {
      const current = changes['appStepAnimation'].currentValue;
      const previous = changes['appStepAnimation'].previousValue;

      if (previous !== undefined && current !== previous) {
        this.animateStepTransition(previous, current);
      }
    }
  }

  private animateStepTransition(from: number, to: number): void {
    const direction = to > from ? 'forward' : 'backward';
    const element = this.el.nativeElement;

    this.removeAnimationClasses(element);

    const className =
      this.orientation === 'horizontal'
        ? direction === 'forward'
          ? 'step-slide-right'
          : 'step-slide-left'
        : direction === 'forward'
          ? 'step-slide-down'
          : 'step-slide-up';

    this.renderer.addClass(element, className);

    // Clean up after animation
    setTimeout(() => this.removeAnimationClasses(element), 500);
  }

  private removeAnimationClasses(element: HTMLElement): void {
    const classes = [
      'step-slide-right',
      'step-slide-left',
      'step-slide-up',
      'step-slide-down'
    ];
    classes.forEach(cls => this.renderer.removeClass(element, cls));
  }

  /** Inject CSS dynamically once */
  private injectStyles(): void {
    if (StepAnimationDirective.stylesInjected) return;
    StepAnimationDirective.stylesInjected = true;

    const styleEl = this.renderer.createElement('style');
    styleEl.textContent = `
      /* Horizontal */
      .step-slide-right {
        animation: slideInFromRight 0.35s cubic-bezier(0.48, -0.08, 0.44, 0.08);
      }
      .step-slide-left {
        animation: slideInFromLeft 0.35s cubic-bezier(0.48, -0.08, 0.44, 0.08);
      }

      @keyframes slideInFromRight {
        from {
          opacity: 0;
          transform: translateX(50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      @keyframes slideInFromLeft {
        from {
          opacity: 0;
          transform: translateX(-50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      /* Vertical */
      .step-slide-down {
        animation: slideInFromBottom 0.35s cubic-bezier(0.48, -0.08, 0.44, 0.08);
      }
      .step-slide-up {
        animation: slideInFromTop 0.35s cubic-bezier(0.48, -0.08, 0.44, 0.08);
      }

      @keyframes slideInFromBottom {
        from {
          opacity: 0;
          transform: translateY(50px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideInFromTop {
        from {
          opacity: 0;
          transform: translateY(-50px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    this.renderer.appendChild(document.head, styleEl);
  }
}
